import { createShipIconTimeline } from "@components/map/mapComponents/shipIcon"
import { DataSetter } from "../utils/mapLayers"
import { getWorldCopyLongitudeOffsets, getWorldCopyPoints } from "./vesselTrackMapEdges"

export const addTimelineEventMarker: DataSetter = (
	dispatch,
	queryClient,
	layerGroup,
	layerData,
	navigate,
	map
) => {
	if (layerGroup === undefined) return

	const { timelineEventMarkerData } = layerData
	if (timelineEventMarkerData === undefined) return

	const { coords, heading } = timelineEventMarkerData
	if (coords === undefined) {
		return
	}

	layerGroup.clearLayers()
	const longitudeOffsets = getWorldCopyLongitudeOffsets(map?.getBounds())

	if (isNaN(coords.lat) === false && isNaN(coords.lon) === false) {
		for (const markerPoint of getWorldCopyPoints(
			{
				latitude: coords.lat,
				longitude: coords.lon,
			},
			longitudeOffsets
		)) {
			layerGroup.addLayer(
				L.marker([markerPoint.latitude, markerPoint.longitude], {
					icon: createShipIconTimeline({ heading: heading ?? 0 }),
					pane: "vesselsPane",
				})
			)
		}
	}
}
